export default __webpack_public_path__ + "static/media/urbano.9b1a93e8.svg";